import React, { useState, useEffect } from "react";
import Layout from "../../../components/Layout";
import WidgetsMonthReview from "../../../components/_widgets/WidgetsMonthReview";
import under_construction from "../../../assets/img/under_construction.svg";
import { WidgetBig, WidgetByCategory, WidgetwithRatingOrder } from "../../../components/_widgets/WidgetsSlider";
import api from "../../../config/api";

require("dotenv").config();

function Dashboard() {
  const [totals, setTotals] = useState({});
  const [rates, setRates] = useState({});
  // const [segment, setSegment] = useState({});
  const [category, setCategory] = useState([]);

  useEffect(() => {
    getTotals();
    getCategory();
    getEstablishmentRates();
  }, []);

  const getTotals = async () => {
    const response = await api.get("/dashboard");
    setTotals(response.data);
  };

  const getEstablishmentRates = async () => {
    const response = await api.get("/dashboard-rates/");
    setRates(response.data);
  };

  const getCategory = async () => {
    let response = await api.get("/establishment?status=active&limit=9999");
    let yCategories = [];
    response.data.forEach((element) => {
      const verifica = yCategories.findIndex((item) => item.name === element.category.name);
      if (verifica >= 0) {
        yCategories[verifica] = {
          img: element.category.slug,
          name: element.category.name,
          qt: yCategories[verifica].qt + 1,
        };
      } else {
        yCategories.push({
          img: element.category.slug,
          name: element.category.name,
          qt: 1,
        });
      }
    });
    setCategory(yCategories);
  };

  return (
    <>
      <Layout defaultMenu={0} title={"Dashboard"} link={""}>
        <div className="dashboard container-fluid px-lg-1">
          <div className="d-flex flex-column flex-lg-row">
            <WidgetsMonthReview
              isMoney={false}
              title={"Total de estabelecimentos"}
              value={totals.totalEstablishment}
              percent={totals.resultEstablishment?.toFixed(2) || 0}
            />
            <WidgetsMonthReview
              isMoney={false}
              className={"my-2 my-lg-0 me-lg-3 ms-lg-3"}
              title={"Total de usuários"}
              value={totals.totalUser}
              percent={totals.resultUser?.toFixed(2) || 0}
            />
            {/* <div className={`card col-12 col-lg padding-32 d-flex justify-content-center align-items-center `}>
              <img src={under_construction} width={196} />
              <span className="ff-univanova-600 " style={{ color: "#979dbe" }}>
                Em construção
              </span>
            </div> */}
            {/* <WidgetsMonthReview isMoney={true} title={"Faturamento mensal"} value={"15000"} percent={-2.25} /> */}
          </div>
          <div className="d-flex flex-column flex-lg-row mt-4 pb-5">
            {/* <WidgetBig className={"d-flex justify-content-center align-items-center"}>
              <div className={`tabs d-flex flex-column align-items-center`}>
                <img src={under_construction} width={196} />
                <span className="ff-univanova-600 " style={{ color: "#979dbe" }}>
                  Em construção
                </span>
              </div>
              <WidgetTabs
                title={"Estabelecimentos por plano"}
                categories={["Ouro", "Prata", "Bronze"]}
                list={[
                  {
                    category: "Ouro",
                    name: "Pet",
                    qt: 45,
                  },
                  {
                    category: "Ouro",
                    name: "Beleza",
                    qt: 12,
                  },
                  {
                    category: "Ouro",
                    name: "Food",
                    qt: 6,
                  },
                  {
                    category: "Ouro",
                    name: "Moda",
                    qt: 32,
                  },
                  {
                    category: "Ouro",
                    name: "Farmácia",
                    qt: 5,
                  },
                  {
                    category: "Ouro",
                    name: "Lazer",
                    qt: 5,
                  },
                  {
                    category: "Prata",
                    name: "yCategories",
                    qt: 43,
                  },
                ]}
              />
            </WidgetBig> */}
            <WidgetBig className={"me-lg-3 mt-2 mt-lg-0"}>
              <WidgetByCategory title="Estabelecimentos por segmento" list={category} />
            </WidgetBig>
            <WidgetBig className={"mt-2 mt-lg-0 me-lg-3"}>
              <WidgetwithRatingOrder title="Avaliações de estabelecimentos" list={rates} />
            </WidgetBig>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default Dashboard;
